export default __webpack_public_path__ + "f5b54ee2555da6cd87c32a54e841bdfd.png";